import React from 'react';
import LocalizedStaticPage from './LocalizedStaticPage';

const MentalHealthPage = () => <LocalizedStaticPage page="mental" />;
export default MentalHealthPage;
